import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

export default function WhatsAppMetadataIcon() {
  return (
    <div className="itemMetadata-whatsAppIcon itemMetadata-fontawesome">
      <FontAwesomeIcon icon={faWhatsapp} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/message/whatsapp_metadata_icon.jsx